<template>
    <div>
        <div class="cta-form-container">
            <span class="logo-1"><img class="img-circle" :src="user.photo_url" alt="" /></span>
            <span class="logo-2"><img src="/images/icon-logo-blue.png" alt="" /></span>
        </div>
        <h3>{{ user.full_name }} é anunciante parceiro da WebQuarto</h3>
        <p>Anunciantes parceiros possuem ferramentas próprias de contato. Clique no botão abaixo para falar diretamente com {{ user.full_name }}. </p>

        <a class="m-t-30 m-b-10 btn btn-lg btn-success btn-block" target="_blank" @click="registerEvent($event)" :href="cta_url">Falar com {{ user.full_name }}</a>
        <p v-if="chat_visible">Se preferir, <button class="btn-link" @click="viewInvitationForm()">use o chat da WebQuarto.</button></p>
    </div>
</template>

<script>
export default {
    props: ['cta_url', 'user', 'fk_property_ad', 'authenticated', 'chat_visible'],
    data () {
        return {};
    },
    methods: {
        viewInvitationForm() {
            EventBus.$emit('view-invitation-form', null);
        },
        registerEvent(e) {
            if (!this.authenticated) {
                EventBus.$emit('open-modal', 'register-modal');
                window.dataLayer.push({
                    'event': 'show_login_modal',
                    'event_category': 'property_ad_page',
                    'event_label': 'cta-form',
                });
                e.preventDefault();
                return false;
            }

            axios.post('/host/cta-webhook', {'fk_receiver': this.user.id, 'fk_property_ad': this.fk_property_ad});

            window.dataLayer.push({
                'event': 'open-cta-url',
                'event_category': 'host-' + this.user.id,
                'event_label': 'property-ad-' + this.fk_property_ad,
			});
        },
    }
}
</script>

<style lang="scss" scoped>
    .cta-form-container {
        display: flex;
        align-content: center;
        justify-content: center;
    }

    .logo-1 {
        margin-right: -15px;
        z-index: 2;
        border: solid 1px #DDD;
        background: #FFF;
        padding: 5px;
    }

    .logo-2 {
        z-index: 1;
    }

    .logo-1, .logo-2 {
        display: inline-flex;
        width: 85px;
        height: 85px;
        border-radius: 50%;
    }
</style>
